import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import URI from "URI/URI";
import utils from "ulysses/widgets/search/utils";
import SearchSelection from "ulysses/widgets/search/search_selection";
import FacetHelper from "ulysses/widgets/search/search_facets";
import SearchItem from "ulysses/widgets/search/search_item";

"use strict";

var search_root = null;


function computeSearchParameters(search_model, settings_obs, context) {
    var search_settings = ko.unwrap(settings_obs);
    var q = computeSearchQuery(search_model, search_settings, context);
    var fq = q.fq;
    delete(q.fq);
    var cf = q.cf;
    delete(q.cf);
    var xf = q.xf;
    delete(q.xf);
    return {
        "q": q,
        "fq": fq,
        "cf": cf ? ko.toJSON(cf): null,
        "xf": xf ? ko.toJSON(xf): null,
        "search_field": "_search_field"
    }; //, "display_mode":search_settings.display_mode };
}

function executeSearchQuery(search_model, settings_obs, context) {
    var search_settings = ko.unwrap(settings_obs);
    var params = computeSearchParameters(search_model, settings_obs, context);
    var starting_point = search_settings && ko.unwrap(search_settings.search_url);
    var search = null;
    if (starting_point) {
        search = HalResource(starting_point);
    } else {
        search = search_root;
        if (!search) {
            search = search_root = uly.api.start().follow("uly:search");
        }
    }

    if (search_settings.display_mode === "grid") {
        var fields = $.map(search_settings.columns || [], function (c) {

            if (c) {
                return c.field;
            } else {
                return undefined;
            }
        });
        params.fields = fields;
    }
    if (search_settings.in_search_popup) {
        params["in_popup"] = true;
    }
    if (!ko.unwrap(search_model.pager.panel_visible)) {
        params["skip_facets"] = true;
    }
    console.log("params:", params);
    var dt = performance.now();
    var search_query = search.follow("uly:results", params, function (result) {
        // $(elt).data("search-updating", true);
        // $(elt).data("search-xhr",null);

        // This fucks up
        // update_parameters_from_query(search_model.parameters, query);
        var search_resource = this;

        search_model.result_title(result.title || null);
        search_model.pager.total(result.total_items || 0);
        if (search_model.pager.search_actions) {
            search_resource.follow_with_cache("uly:actions", uly.api.action_cache).done(function (actions) {
                search_model.pager.search_actions(actions);
            }).fail(function (error) {
                search_model.pager.search_actions([]);
            });
        }
        search_resource.has_rel("previous").done(function () {
            search_model.pager.prev(search_resource.has_rel_s("previous"));
            search_model.pager.next(search_resource.has_rel_s("next"));
            search_model.pager.start_index(result.start_index);
            search_model.pager.page_size(result.page_size);
            search_model.pager.tot_page(ko.unwrap(search_model.pager.total) ? parseInt(ko.unwrap(search_model.pager.total) / ko.unwrap(search_model.pager.page_size), 10) : 0);
            // $(elt).data("search-updating", false);
            // uly.publish("widget.active", elt);
            console.log(
                "Search Query Timings: server:", result["request_time"] * 1000, 
                "client:", performance.now() - dt, 
                "difference:", (performance.now() - dt) - (result["request_time"] * 1000)
            );
            search_model.last_query_timing(result["request_time"] * 1000);
            search_model.last_query_full(performance.now() - dt);
            setTimeout(function () {
                search_model.busy(false);
            }, 250);
        });

        search_model.faceting.updateFacetUI(result.facets);

        if (result.sortables) {
            search_model.pager.sortables(result.sortables);
        }
        if (result.saved_filters) {
            search_model.pager.saved_filters(result.saved_filters);
        } else {
            search_model.pager.saved_filters([]);
        }
        if (result.facet_sets) {
            search_model.pager.facet_sets(result.facet_sets);
        } else {
            search_model.pager.facet_sets([]);
        }

    });
    search_query.start_time = Date.now();

    return search_query.follow("item").then(function (data) {
        //todo: transform properly
        var items = $.map(data || [], function (item, idx) {
            item = new SearchItem.searchify_item(item);
            item.collapsed(search_model.pager.display_mode() === "list");
            uly.publish("search.result.show", item);
            return item;
        });
        if (ko.unwrap(search_model.external)) {
            for (var i = 0; i < items.length; i++) {
                search_model.results.push(items[i]);
            }
        } else {
            search_model.clear_results();
            
            search_model.results(items || []);
            search_model.callback.valueHasMutated();
        }
        //search_model.results(search_model.results() + items)

        search_model.error(null);
        search_model.external(false);
        return search_model.results();
    }, function (result) {
        search_model.results([]);
        search_model.error(_("search_execute_search_query_search_error", "Search error..."));
        search_model.busy(false);
    });

}

function filterSearchByPage(query, settings, search_model, context) {
    if (!query)
        return;
    if ("pager" in search_model) {
        if (ko.unwrap(search_model.pager.page_size))
            query.page_size = ko.unwrap(search_model.pager.page_size);
        if (ko.unwrap(search_model.pager.start_index) >= 0)
            query.start_index = ko.unwrap(search_model.pager.start_index) || 0;
    }
    var contextual = ko.unwrap(settings.contextual);
    if (typeof contextual == "undefined" || contextual === null)
        contextual = true;

    var filter = ko.unwrap(settings.filter);
    query.fq = [];

    if (filter) {
        query.fq.push(filter);
    }

    var relation = ko.unwrap(settings.relation);
    if (relation) {
        contextual = true;
        query._relation = relation;
    }


    var entity = uly.utils.get_bound_resource(context);
    if (!entity)
        return query;

    if (!contextual || contextual === "no") {
        query._origin = ko.unwrap(entity.unique_id)
        return query;
    }

    var type = ko.unwrap(entity.content_type);
    var use_screen = ko.unwrap(settings.use_screen_configuration);
    if (entity.unique_id) {
        if (!use_screen && ko.unwrap(entity.unique_id).indexOf("Page") !== 0) {
            query._parent = ko.unwrap(entity.unique_id);
        } else if (use_screen) {
            query._config_source = ko.unwrap(entity.unique_id);
        }
    } else if (type == "collection" && ko.unwrap(entity.type)) {
        query._type = ko.unwrap(entity.type).toLowerCase();
    }
    return query;
}

function computeSearchQuery(search_model, search_settings, context) {
    var query = ko.toJS(search_model.parameters) || {};
    var rendered_filter = ko.unwrap(search_model.pager.rendered_filter);
    var active_facets = ko.unwrap(search_model.faceting.active);
    var custom_facets = ko.unwrap(search_model.faceting.custom);
    var custom_controls = ko.unwrap(search_model.faceting.custom_controls);
    var search_sort = ko.unwrap(search_model.pager.search_sort);
    var hardcoded_model = ko.unwrap(search_model.hardcoded_model);
    var expanded_facets = ko.unwrap(search_model.faceting.widgets).filter((w) => {
        return !ko.unwrap(w.expandable) || ko.unwrap(w.expanded);
    }).map((w)=>{
        return w.name
    });

    query = filterSearchByPage(query, search_settings, search_model, context);
    var q = query;
    if (query._search_body && query._search_body.indexOf("is:selected") >= 0) {
        if (search_model.pager.selection().length !== 0) {
            query.fq.push($.map(search_model.pager.selection(), function (val, idx) {
                if (val.id) {
                    return "id:" + val.unique_id;
                } else return "id:" + val;
            }).join(" OR "));
            q = copy_without_wildcard(query);
        }
    }
    if (rendered_filter) {
        if (q.fq) {
            q.fq.push(rendered_filter);
        } else {
            q.fq = [rendered_filter];
        }
    }
    if (active_facets) {
        var joins = {

        };

        q.fq = q.fq || [];
        $.each(active_facets, function (idx, facet) {
            if (facet.selector) {
                var or_groups = {}
                var j = null;
                if (facet.join) {
                    j = joins[facet.join];
                    if (!j) {
                        j = joins[facet.join] = { "join": facet.join, "groups": {}, no_groups:[], "domain_filter": facet.domain_filter };
                    }
                } else {
                    j = joins["__null"];
                    if (!j) {
                        j = joins["__null"] = { groups: {}, no_groups:[] };
                    }
                }
                or_groups = j.groups;

                if (facet.or_group) {
                    or_groups[facet.or_group] = or_groups[facet.or_group] || [];
                    or_groups[facet.or_group].push(facet.selector);
                    if (facet.join) {
                        or_groups[facet.or_group]._join = facet.join;
                        or_groups[facet.or_group]._domain_filter = facet.domain_filter;

                    }
                }
                else
                    j.no_groups.push(facet.selector);
            }
        });
        Object.keys(joins).forEach(function(join_key) {
            var join = joins[join_key];
            var j = join.join;
            var dom_filter = join.domain_filter;
            var fqs = [];
            var or_groups = join.groups;
            Object.keys(or_groups).forEach((key) => {
                var g = or_groups[key];
                if (g.length == 1) {
                    fqs.push("{!tag="+key+"}(" + g[0] + ")");
                } else if (g.length > 1) {
                    console.log("got group:", g);
                    fqs.push("{!tag="+key+"}(" + g.join(" OR ") + ")");
                }
            })
            join.no_groups.forEach((f) => { fqs.push(f); });
            if (j) {
                if (dom_filter && dom_filter != "") {
                    fqs.push(dom_filter);
                    q.fq.push(j+fqs.join(" AND "));
                } else {
                    q.fq.push(j+fqs.join(" AND "));
                }
            } else {
                fqs.forEach((f) => { q.fq.push(f); });
            }
        });
    }
    var cf = [];
    var xf = [];
    expanded_facets.forEach((v) => { xf.push(v) });
    if (custom_facets) {
        custom_facets.forEach(function(v) {
            if (v.facet_type && v.facet_type != "string")
                cf.push({"n":v.name, "k":v.facet_type});
        });
    }
    if (custom_controls) {
        custom_controls.forEach(function(v) {
            if (v.facet_type && v.facet_type != "string")
                cf.push({"n": v.name, "k": v.facet_type})
                xf.push(v.name);
        })
    }
    q.cf = cf;
    q.sort = search_sort;
    q = clean_query(q);
    if (search_model.dynamic_faceting()) {
        q.xf = xf;
    }
    if (search_settings.display_mode) {
        q.display_mode = ko.unwrap(search_settings.display_mode);
    }
    if (hardcoded_model) {
        q.__model = hardcoded_model;
    }
    if (search_model.current_facet_set()) {
        q.fs = search_model.current_facet_set();
    }
    return q;
}

function copy_without_wildcard(query) {
    var wildcards = ["is:selected"];
    return $.extend(ko.toJS(query), {
        _search_body: query._search_body.replace(new RegExp(wildcards.join("|")), "")
    });
}

function clean_query(query) {
    $.each(query, function (key, value) {
        if (typeof value == "undefined" || value === null ||
                value === "" || (Array.isArray(value) && value.length === 0))
            delete query[key];
    });
    return query;
}

export default {
    "computeSearchQuery": computeSearchQuery,
    "executeSearchQuery": executeSearchQuery,
    "computeSearchParameters": computeSearchParameters,
    "filterSearchByPage": filterSearchByPage


};
